import { createContext, useContext } from 'react';

const ModalContext = createContext({
  onClose: () => void 0,
  showCloseButton: true,
  variant: "base",
  size: "md",
  isDismissible: true,
  scrollBehavior: "inside"
});
const useModalContext = () => {
  const context = useContext(ModalContext);
  return context;
};

export { ModalContext, useModalContext };
//# sourceMappingURL=ModalContext.es.js.map
